import { render } from "./Pagination.vue?vue&type=template&id=10751d4b"
import script from "./Pagination.vue?vue&type=script&lang=js"
export * from "./Pagination.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/js/vue/components/common/Pagination.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "10751d4b"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('10751d4b', __exports__)) {
    api.reload('10751d4b', __exports__)
  }
  
  module.hot.accept("./Pagination.vue?vue&type=template&id=10751d4b", () => {
    api.rerender('10751d4b', render)
  })

}


export default __exports__